module.exports = ".example-fill-remaining-space {\n  flex: 1 1 auto;\n}\n\na {\n  cursor: pointer;\n}\n\n.nav-buttons {\n  padding-right: 5px;\n}\n\n"